import { useMemo } from 'react';

import { matchPath } from '@kc-console/core';

import useRouter from './useRouter';
import useServiceAppState from './useServiceAppState';
import useServiceMetaQuery from './useServiceMetaQuery';

/**
 * 현재 URL과 매칭되는 route를 즉시 반환하는 훅입니다.
 * @description
 * - 일반적으로 route는 URL이 변경되면 useServiceRouteEffect에서 useEffect로 결정한 후 사용하게 됩니다.
 * - 이 훅은 useMemo를 사용하여 렌더링 시점에 즉시 계산되므로, SSR <-> CSR 하이드레이션 에러를 방지하고 즉각적으로 변경된 route를 사용할 수 있습니다.
 */
export default function useFindUrlMatchedRoute() {
  const router = useRouter();

  const { state: appState } = useServiceAppState();
  const { serviceKeyword } = appState;

  const { data: serviceMeta } = useServiceMetaQuery();
  const routes = useMemo(() => serviceMeta?.routes || [], [serviceMeta?.routes]);

  return useMemo(() => {
    const pathname = router.asPath.split('?')[0];
    const routePath = pathname.replace(`${serviceKeyword}/`, '');
    return routes?.find(route => matchPath(routePath, route.path)) || null;
  }, [router.asPath, routes, serviceKeyword]);
}
